// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
/* eslint-disable -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved. */
import React from "react";
import { Description as DescriptionIcon } from "@mui/icons-material";

import { Button } from "@/components/core/button";
import custAccountOperationServices from "@/services/accounts";

export function PdfDownloader({ uptReferance, title }: any) {
  const downloadPdf = async () => {
    try {
      const response = await custAccountOperationServices.getTransferReceipt(
        { uptReferance: String(uptReferance) },
        { responseType: "blob" }
      );

      const base64String = response.data.body.result;
      const binaryString = atob(base64String);
      const binaryLen = binaryString.length;
      const bytes = new Uint8Array(binaryLen);

      for (let i = 0; i < binaryLen; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const pdfBlob = new Blob([bytes], { type: "application/pdf" });
      const url = window.URL.createObjectURL(pdfBlob);
      const tempLink = document.createElement("a");
      const date = new Date().toISOString().split("T")[0];
      tempLink.href = url;
      tempLink.setAttribute("download", `bill_${date}.pdf`);

      document.body.appendChild(tempLink);
      tempLink.click();

      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  return (
    <Button onClick={downloadPdf} startIcon={<DescriptionIcon />} color="inherit">
      {title}
    </Button>
  );
}
